export default "__VITE_ASSET__7c77c06c__"